'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'
import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/shared/event-tracker'
import { useTranslate } from '@marketplace-web/shared/i18n'
import { useAsset } from '@marketplace-web/domain/assets'
import { viewScreenEvent } from '_libs/common/event-tracker/events'
import { Screen } from 'constants/tracking/screens'

const FailedState = () => {
  const { track } = useTracking()
  const translate = useTranslate('business.wallet.status.failed')
  const asset = useAsset('/assets/kyc')

  useEffect(() => {
    track(
      viewScreenEvent({
        screen: Screen.WalletConversion,
      }),
    )
  }, [track])

  return (
    <div className="u-flexbox u-flex-direction-column u-align-items-center">
      <Image
        src={asset('cross.svg', { theme: { dark: 'dark/cross.svg' } })}
        size={Image.Size.X2Large}
      />
      <Spacer size={Spacer.Size.XLarge} />
      <Text
        as="h1"
        type={Text.Type.Heading}
        alignment={Text.Alignment.Center}
        text={translate('title')}
      />
      <Spacer />
      <Text as="span" alignment={Text.Alignment.Center} html text={translate('body')} />
    </div>
  )
}

export default FailedState
